function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFliter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.141,
    height: 28.904,
    viewBox: "0 0 36.141 28.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17955",
    transform: "translate(-1487.859 -290.548)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 109",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1490 302)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 110",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1503 292)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 111",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1516 306)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12854",
    d: "M36.778-434.622a1.087 1.087 0 0 0-.541.55c-.186.356-.186.356-.186 4.671v4.316l-.178.048a6.044 6.044 0 0 0-.816.364 5.017 5.017 0 0 0-2.449 2.966 6.068 6.068 0 0 0 0 2.748 5.017 5.017 0 0 0 2.449 2.966 6.04 6.04 0 0 0 .816.364l.178.048v4.316c0 4.316 0 4.316.186 4.671a1.28 1.28 0 0 0 1.245.7 1.5 1.5 0 0 0 1.01-.647 34.431 34.431 0 0 0 .145-4.615l.04-4.437.412-.137a5.075 5.075 0 0 0 3.063-3.435 6.02 6.02 0 0 0 0-2.344 5.081 5.081 0 0 0-3.039-3.427l-.436-.154-.04-4.437a34.348 34.348 0 0 0-.145-4.607 1.5 1.5 0 0 0-1.01-.647 1.144 1.144 0 0 0-.704.159zm1.4 12.074a2.383 2.383 0 0 1 1.317 3.217 2.364 2.364 0 0 1-3.815.638 2.372 2.372 0 0 1 .913-3.871 2.856 2.856 0 0 1 1.583.016z",
    transform: "translate(1455.409 725.338)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12855",
    d: "M198.879-434.757a4.9 4.9 0 0 0-2.222 1.277 4.443 4.443 0 0 0-1.471 3.281 4.4 4.4 0 0 0 .5 2.473 4.928 4.928 0 0 0 2.546 2.344l.566.218v9.1c0 8.7.008 9.116.154 9.383a1.289 1.289 0 0 0 2.174.178l.218-.283.024-9.189.016-9.189.477-.178a5.049 5.049 0 0 0 2.627-2.376A4.3 4.3 0 0 0 205-430.2a4.443 4.443 0 0 0-1.471-3.281 4.929 4.929 0 0 0-2.263-1.285 6.226 6.226 0 0 0-2.387.009zm2.053 2.618a2.318 2.318 0 0 1 1.487 2.029 2.194 2.194 0 0 1-.558 1.713 2.14 2.14 0 0 1-1.77.784 2.14 2.14 0 0 1-1.77-.784 2.194 2.194 0 0 1-.558-1.713 2.325 2.325 0 0 1 3.169-2.028z",
    transform: "translate(1305.834 725.424)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12856",
    d: "M362.4-434.706a1.343 1.343 0 0 0-.679.719c-.065.154-.089 2.328-.089 6.756v6.53l-.339.105a3.854 3.854 0 0 0-1.406.76 4.863 4.863 0 0 0-1.887 3.863 4.436 4.436 0 0 0 .493 2.158 4.987 4.987 0 0 0 2.255 2.271 4.885 4.885 0 0 0 .784.323c.081 0 .105.436.105 2.142 0 2.4.024 2.53.517 2.909a1.256 1.256 0 0 0 1.891-.444c.17-.348.178-.436.178-2.473v-2.113l.307-.1a5.892 5.892 0 0 0 1.7-1.01 5.694 5.694 0 0 0 1.4-2.15 5.59 5.59 0 0 0 .016-2.942 5.151 5.151 0 0 0-3.063-3.2l-.356-.105v-13.028l-.178-.356a1.3 1.3 0 0 0-1.649-.615zm1.5 16.592a2.58 2.58 0 0 1 .7.517 2.392 2.392 0 0 1-.655 3.766 2.8 2.8 0 0 1-.913.17 2.009 2.009 0 0 1-1.673-.55 2.052 2.052 0 0 1-.768-1.624 1.7 1.7 0 0 1 .218-1.164 2.21 2.21 0 0 1 2.19-1.309 3.13 3.13 0 0 1 .909.194z",
    transform: "translate(1156.169 725.357)",
    style: {
      fill: "#6f7e8e"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFliter);
export default __webpack_public_path__ + "static/media/fliter.2f3976e67a3a5f97f0d8d51d378bfcce.svg";
export { ForwardRef as ReactComponent };